import {createSlice} from '@reduxjs/toolkit';
import {
    ICartData,
    ICartItem
} from '../../shopping-cart/cart-bridger-pay/interfaces';
import {cloneDeep} from 'lodash';
import {formatCartData} from '../../shopping-cart/cart-bridger-pay/data/data-provider';
import {getProductsCount} from '../../shopping-cart/cart-bridger-pay/domain/shopping-cart-provider';
import {UPDATE_MINI_CART_COUNT_EVENT} from '../../site-header/top-minicart/ui/main';
import {IListItem} from '../../list-page/interfaces/interfaces';

interface IState{
    cartData: ICartData|null;
    addedCartItem: ICartItem|null;
    addedCartItemAdditionalData: IListItem|null;
}

const initialState: IState = {
    cartData: null,
    addedCartItem: null,
    addedCartItemAdditionalData: null
};

const rootSlice = createSlice({
    name: 'root',
    initialState,
    reducers: {

        main(state, action) {
            return {
                ...state,
                ...action.payload,
            }
        },

        setCartData(state, action) {

            const updatedCartData = formatCartData(cloneDeep(action.payload));

            if(!state.cartData || (state.cartData && getProductsCount(state.cartData.cartItems) !== getProductsCount(updatedCartData.cartItems))) {

                // update top min-cart products count -----------------
                document.dispatchEvent(new CustomEvent(UPDATE_MINI_CART_COUNT_EVENT));
            }

            return {
                ...state,
                cartData: updatedCartData,
            }
        },
    }
});

export default rootSlice;